<template>

  <div v-if="data.type==''" class="et-property__empty">&lt;请选择元件&gt;</div>

  <div class="et-property__item" v-if="getVisible('name')">
    <div class="et-property__label">名称</div>
    <input type="text" class="et-property__value" @input="onNameInput" v-model="data.name" placeholder="请输入名称">
  </div>

  <div class="et-property__item" v-if="getVisible('isShowProperty')">
    <div class="et-property__label">显示属性</div>
    <div class="et-property__value">
      <EtSwitch v-model="data.isShowProperty" @change="onIsShowPropertyChange" active-text="显示" inactive-text="隐藏"></EtSwitch>
    </div>
  </div>

  <div class="et-property__item" v-if="getVisible('meterType')">
    <div class="et-property__label">电表类型</div>
    <div class="et-property__value">
      <select class="et-property__select" v-model.number="data.meterType" @change="onMeterTypeChange">
        <option v-for="opt in MeterTypes" :key="opt.value" :value="opt.value">{{ opt.label }}</option>
      </select>
    </div>
  </div>


  <div class="et-property__item" v-if="getVisible('text')">
    <div class="et-property__label">文本内容</div>
    <input type="text" class="et-property__value" @input="onTextInput" v-model="data.text" placeholder="请输入文本内容">
  </div>

  <div class="et-property__item" v-if="getVisible('fill')">
    <div class="et-property__label">填充</div>
    <div class="et-property__value">
      <ColorPicker v-model="data.fill" @change="onFillInput" />
    </div>
  </div>

  <div class="et-property__item" v-if="getVisible('stroke')">
    <div class="et-property__label">描边</div>
    <div class="et-property__value">
      <ColorPicker v-model="data.stroke" @change="onStrokeInput" />
    </div>
  </div>
  <div class="et-property__item" v-if="getVisible('strokeWidth')">
    <div class="et-property__label">线宽</div>
    <div class="et-property__value">
      <LineWidthPicker :lineWidths="lineWidths" v-model="data.strokeWidth" @change="onStrokeWidthChange" />
    </div>
  </div>

  <div class="et-property__item" v-if="getVisible('lineStyle')">
    <div class="et-property__label">线条样式</div>
    <div class="et-property__value">
      <LineStylePicker v-model="data.lineStyle" @change="onLineStyleChange" />
    </div>
  </div>



  <div class="et-property__item" v-if="getVisible('busColor')">
    <div class="et-property__label">母线颜色</div>
    <div class="et-property__bus">
      <div class="et-bus-color" v-for="c of BusColors" :class="getBusClass(c)" :style="{ background: c }"
        @click="onBusColorClick(c)">
      </div>

    </div>
  </div>

  <div class="et-property__item" v-if="getVisible('uuid')">
    <div class="et-property__label">设备UUID</div>
    <input class="et-property__value" disabled v-model="data.uuid" placeholder="选择设备后UUID自动填入">
  </div>

  <div class="et-property__item" v-if="getVisible('offset')">
    <div class="et-property__label">方阵偏移量</div>
    <div class="et-property__value" style="display: flex; align-items: center; justify-content: space-between;">
      <input @input="onOffsetInput" class="et-property__range" type="range" min="0" max="100" step="0.01"
        v-model="data.offset">
      <input @input="onOffsetInput" v-model="data.offset" type="number" step="0.1"
        style="color: rgb(33, 150, 243); margin: 0px 4px; width: 80px; border-radius: 3px;">
    </div>
  </div>



  <div class="et-property__item" v-if="getVisible('groundSwitch')">
    <div class="et-property__label">接地开关</div>
    <div class="et-property__value" style="display: flex; align-items: center;gap: 8px;">
      <EtSwitch v-model="data.groundSwitch" @change="onGroundSwitchChange"></EtSwitch>
    </div>
  </div>

  <div class="et-property__item" v-if="getVisible('direction')">
    <div class="et-property__label">水平方向</div>
    <div class="et-property__value" style="display: flex; align-items: center;gap: 8px;">
      <DirectionSwitch v-model="data.horizontalDirection" left-text="左" right-text="右" left-value="left" right-value="right" @change="onHorizontalDirectionChange"></DirectionSwitch>
    </div>
  </div>

  <div class="et-property__item" v-if="getVisible('direction')">
    <div class="et-property__label">垂直方向</div>
    <div class="et-property__value" style="display: flex; align-items: center;gap: 8px;">
      <DirectionSwitch v-model="data.verticalDirection" left-text="上" right-text="下" left-value="up" right-value="down" @change="onVerticalDirectionChange"></DirectionSwitch>
    </div>
  </div>

  <div class="et-property__item" v-if="getVisible('lineWidth')">
    <div class="et-property__label">线宽</div>
    <input type="number" class="et-property__value" @input="onLineWidthInput" v-model.number="data.lineWidth" 
      placeholder="请输入线宽" min="1" step="1">
  </div>

  <div class="et-property__item" v-if="getVisible('lineHeight')">
    <div class="et-property__label">线高</div>
    <input type="number" class="et-property__value" @input="onLineHeightInput" v-model.number="data.lineHeight" 
      placeholder="请输入线高" min="1" step="1">
  </div>


  <div class="et-property__item" v-if="getVisible('deviceSelect')">
    <div class="et-property__label">设备选择</div>
    <div class="et-property__value" style="display: flex;flex-direction: column; flex: 1">
      <div class="et-tree__view">
        <div class="et-tree__title no-margin">储能方阵</div>
        <div style="overflow-y: auto;max-height: 220px">
          <template v-for="dataItem in data.matrix">
            <div class="et-tree__item square" :class="{ active: getActive('square-' + dataItem.uuid) }"
              @click="select('square-' + dataItem.uuid, 'square', dataItem.sort + '#储能方阵')">
              <span class="et-tree__open" @click="toggleOpen(dataItem, $event)">{{ dataItem.open ? '+' : '-' }}</span>
              <span class="et-tree__unit-name">{{ dataItem.sort }}#储能方阵</span>
            </div>
            <div class="et-tree__view" v-if="!dataItem.open">
              <div class="et-tree__item elk" :class="{ active: getActive(dataItem.uuid) }"
                @click="select(dataItem.uuid, 'eLink', dataItem.eLinkName)" :title="dataItem.uuid">{{ dataItem.eLinkName }} <span
                  class="et-tree__tag elk">elk</span></div>
              <div class="et-tree__item eb" :class="{ active: getActive(eb.uuid) }" v-for="eb in dataItem.eBlocks"
                @click="select(eb.uuid, 'eBlock', eb.eBlockName)" :title="eb.uuid"><!-- {{ eb.sort }}# -->{{ eb.eBlockName }} <span
                  class="et-tree__tag eb">eb</span></div>
            </div>
          </template>
        </div>
        <div class="et-tree__title">其他设备</div>
        <div style="overflow-y: auto;max-height: 160px">
          <div v-for="tfm in data.tfms" class="et-tree__item tfm" :class="{ active: getActive(tfm.uuid) }"
            @click="select(tfm.uuid, 'transformer', tfm.transformerName)" :title="tfm.uuid">
              <span class="et-tree__name">{{ tfm.transformerName }}</span>
              <span class="et-tree__tag tfm">tfm</span></div>
          <div v-for="mt in data.meters" class="et-tree__item mt" :class="{ active: getActive(mt.uuid) }"
            @click="select(mt.uuid, 'pcc', mt.meterName)" :title="mt.uuid">{{ mt.meterName }} <span class="et-tree__tag mt">mt</span>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script setup>
import { ref, reactive, computed, onMounted, onUnmounted, watch, inject, toRefs, nextTick } from 'vue'
// import { getAllMatrix, getTransformerList, getMeterList } from "@/api/paramSetting/deviceManage"
// import { modifyTopo } from "@/api/paramSetting/topo"
import { GraphElement } from '@/topo/core/graph-element.js'
import { BusElement, CircleElement, ESSElement, GroundElement, RectElement, SquareElement, TextElement, FoldLineElement, PCCElement } from "@/topo/core/element"
import { ElMessage } from 'element-plus'
import {clamp} from '@/topo/core/utils/index.js'
import ColorPicker from './components/color-picker.vue'
import EtSwitch from './components/switch.vue'
import DirectionSwitch from './components/direction-switch.vue'
import LineWidthPicker from './components/line-width-picker.vue'
import LineStylePicker from './components/line-style-picker.vue'
import EtTab from './components/tab.vue'


// api
import { getDevicesByIdV2 } from '@/api/modules/station/index.js'
import { getHashQuery } from '@/topo/core/utils/dom.js'




const topology = inject('topology')
const data = reactive({
  tab: 1,
  matrix: [],
  tfms: [],
  meters: [],
  currentSelected: null,

  /* formvalues */
  type: '',
  name: '',
  uuid: '',
  offset: 0,
  text: '',
  fill: '#000',
  stroke: '#fff',
  strokeWidth: 1,
  lineStyle: 'solid',
  groundSwitch: true,
  busColor: '#C3CCFE',
  horizontalDirection: 'right',
  verticalDirection: 'down',
  lineWidth: 40,
  lineHeight: 20,
  isShowProperty: true,
  meterType: 1,
})

// 电表类型: 关口电表:1, 并网电表:3, 负载电表:4, 光伏电表:5
const MeterTypes = [
  { value: 1, label: '关口电表' },
  { value: 3, label: '并网电表' },
  { value: 4, label: '负载电表' },
  { value: 5, label: '光伏电表' },
]

const lineWidths = computed(() => {
  return (data.type == 'bus') ? [10, 8, 6, 4, 2, 1] : [1, 2, 3, 5, 8]
})


const BusColors = [
  '#C3CCFE ',
  '#FC9646',
  '#F93342',
  '#2CD563',
  'blue',
]

function getVisible(propertyName) {
  const visibles = {
    /* base */
    text: ['text', 'fill'],
    circle: ['name', 'fill', 'stroke', 'strokeWidth', 'lineStyle'],
    rect: ['name', 'fill', 'stroke', 'strokeWidth', 'lineStyle'],
    foldLine: ['name', 'stroke', 'strokeWidth', 'direction', 'lineWidth', 'lineHeight'],

    /* device */
    bus: ['name', 'busColor', 'strokeWidth'],
    eBlock: ['name', 'uuid', 'deviceSelect'],
    eLink: ['name', 'uuid', 'deviceSelect'],
    ess: ['name', 'uuid', 'deviceSelect'],
    payload: ['name', 'uuid', 'deviceSelect', 'isShowProperty'],
    pcc: ['name', 'uuid', 'meterType', 'deviceSelect'],
    pcs: ['name', 'uuid', 'deviceSelect'],
    pv: ['name', 'uuid', 'deviceSelect'],
    transformer: ['name', 'uuid', 'deviceSelect', 'isShowProperty'],
    square: ['name', 'uuid', 'offset', 'deviceSelect'/* , 'busColor' */],
    breaker: ['name', 'uuid', 'deviceSelect'],
    chargePile: ['name'],
    ground: ['name', 'groundSwitch'],
  }
  const arr = visibles[data.type] || []
  return arr.includes(propertyName)
}


//////////////////////////////////


// 当前选中的元素
let elem
// 监听topo图中元素选择事件
topology.addEventListener('topo:select', (event) => {
  console.log('topo:select', event);

  elem = event.data

  if (elem instanceof GraphElement) {
    // 设置类型
    data.type = elem.type
    // 设置名称和设备UUID
    data.name = elem.label.getText()
    data.uuid = elem.deviceUUID
    scroll()

    // 填充和描边
    data.fill = elem.keyShape.fill()
    data.stroke = elem.keyShape.stroke()
    data.strokeWidth = elem.keyShape.strokeWidth()
    
    // 是否显示属性
    data.isShowProperty = elem.prop_is_show


    // 方阵偏移量
    if (elem instanceof SquareElement) {
      data.offset = elem.eBlockOffsetPercentage

    }
    // 母线颜色
    if (elem instanceof BusElement) {
      log('--->', elem.keyShape.fill())
      data.busColor = elem.keyShape.fill()
      data.strokeWidth = elem.keyShape.height()
    }
    // 文本
    if (elem instanceof TextElement) {
      data.text = elem.keyShape.getAttr('text')
    }

    // 接地开关状态
    if (elem instanceof GroundElement) {
      data.groundSwitch = elem.switchValue
    }

    // 电表类型
    if (elem instanceof PCCElement) {
      data.meterType = elem.meterType ?? 1
    }

    // 折线方向和尺寸
    if (elem instanceof FoldLineElement) {
      data.horizontalDirection = elem.horizontalDirection || 'right'
      data.verticalDirection = elem.verticalDirection || 'down'
      data.lineWidth = elem.lineWidth || 40
      data.lineHeight = elem.lineHeight || 20
    }

    if (elem instanceof CircleElement || elem instanceof RectElement) {
      data.lineStyle = elem.keyShape.getAttr('dash')?.length ? 'dashed' : 'solid'
    }


  } else {
    // 未选中任何元素
    data.type = ''
    data.name = ''
    data.uuid = ''
    data.offset = 0
  }
})


/**
 * 属性显示开关改变时
 * @param val 
 */
function onIsShowPropertyChange(val) {
  if (elem instanceof GraphElement) {
    elem.setPropertyVisible(val)
  }
}


/**
 * 方阵偏移量改变
 */
function onOffsetInput() {
  const val = clamp(0, 100, data.offset)
  if (elem instanceof SquareElement) {
    elem.updateEBlockOffsetPercentage(val)
  }
}

function onGroundSwitchChange(val) {
  if (elem instanceof GroundElement) {
    elem.setSwitch(val)
  }
}

/**
 * 电表类型改变时
 */
function onMeterTypeChange() {
  if (elem instanceof PCCElement) {
    elem.setMeterType(data.meterType)
  }
}

/**
 * 水平方向改变时
 */
function onHorizontalDirectionChange(val) {
  if (elem instanceof FoldLineElement) {
    elem.setHorizontalDirection(val)
  }
}

/**
 * 垂直方向改变时
 */
function onVerticalDirectionChange(val) {
  if (elem instanceof FoldLineElement) {
    elem.setVerticalDirection(val)
  }
}

/**
 * 宽度改变时
 */
/**
 * 线宽改变时
 */
function onLineWidthInput() {
  if (elem instanceof FoldLineElement) {
    const val = Math.max(1, Number(data.lineWidth) || 40)
    elem.setLineWidth(val)
    // 同步数据，确保显示正确的值
    data.lineWidth = val
  }
}

/**
 * 线高改变时
 */
function onLineHeightInput() {
  if (elem instanceof FoldLineElement) {
    const val = Math.max(1, Number(data.lineHeight) || 20)
    elem.setLineHeight(val)
    // 同步数据，确保显示正确的值
    data.lineHeight = val
  }
}

/**
 * 名称改变时
 */
function onNameInput() {
  if (elem instanceof GraphElement) {
    elem.label.setText(data.name)
  }
}

/**
 * 文本输入时
 */
function onTextInput() {
  if (elem instanceof TextElement) {
    // elem.label.setText(data.text)
    elem.keyShape.setAttr('text', data.text)
  }
}

/**
 * 填充改变时
 */
function onFillInput() {
  if (elem instanceof GraphElement) {
    elem.keyShape.fill(data.fill)
  }
}


/**
 * 描边改变时
 * @param color
 */

function onStrokeInput() {
  if (elem instanceof GraphElement) {
    elem.keyShape.stroke(data.stroke)
  }
}

/**
 * 描边宽度改变时
 */
function onStrokeWidthChange() {
  if (elem instanceof GraphElement) {
    elem.keyShape.strokeWidth(data.strokeWidth)
  }

  // 母线时设置母线的高度
  if (elem instanceof BusElement) {
    elem.keyShape.height(data.strokeWidth)
  }

  // topology.painter.paint()
}


function onLineStyleChange() {
  if (elem instanceof CircleElement || elem instanceof RectElement) {
    elem.keyShape.setAttr('dash', data.lineStyle === 'solid' ? [] : [5, 5])
  }
}



function getBusClass(color) {
  return {
    'et-bus-color': true,
    'active': data.busColor === color
  }
}

function onBusColorClick(color) {
  data.busColor = color

  if (elem instanceof BusElement) {
    elem.keyShape.fill(color)
  }
}



function getActive(val) {
  return data.uuid == val
}


/**
 * 选择右侧设备
 * @param uuid uuid
 * @param type 设备类型
 */
function select(uuid, type, name) {
  console.log('select', uuid, type, data.type)

  if (data.type !== type) {
    if (type == 'square' && data.type == 'ess') {

    } else {
      ElMessage.warning('请选择正确的设备类型')
      return
    }
  }

  data.uuid = uuid
  data.name = name

  if (elem instanceof GraphElement) {
    elem.deviceUUID = uuid
    elem.setLabel(name)
  }

  if (elem instanceof SquareElement) {
    const dt = findSquareDataByUUID(uuid)
    elem.setData(dt)
  }

  if (elem instanceof ESSElement) {
    const dt = findSquareDataByUUID(uuid)
    elem.setData(dt)
  }

  ElMessage.success('选择成功')

}

/**
 * 根据方阵UUID获取数据项
 * @param sqUUID 方阵UUID
 */
function findSquareDataByUUID(sqUUID = '') {
  let [t, uuid] = sqUUID.split('-')
  for (const dataItem of data.matrix) {
    if (uuid === dataItem.uuid) {
      return dataItem
    }
  }
}

function scroll() {
  nextTick(() => {
    let act = document.querySelector('.et-tree__item.active')
    act && act.scrollIntoView({ behavior: 'smooth' })
  })
}


/**
 * 储能方阵展开与收起
 * @param dataItem 数据项
 * @param event 事件对象
 */
function toggleOpen(dataItem, event) {
  dataItem.open = !dataItem.open
  event.stopPropagation()
}

//////////////////////////////////

async function updateData() {


  try {
    const stationId = getHashQuery('stationId')

    if(!stationId) {
      return
    }

    const r = await getDevicesByIdV2(stationId)
    // console.log('------------------------>', r);
    data.matrix = r.data.eLinks

    data.tfms = r.data.transformers
    data.meters = r.data.outerMeters

    // getAllMatrix().then(r => {
    //   data.matrix = r.data
    // })
    // getTransformerList().then(r => {
    //   data.tfms = r.rows
    // })
    // getMeterList().then(r => {
    //   data.meters = r.rows
    // })
  } catch (error) {

  }

}


updateData()





</script>
